var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEmail, IsIn, IsInt, IsObject, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { MediaSummary } from '../commons/medias/media';
import { Fact } from './facts/fact';
import { Links } from './links/links';
import { Location } from './locations/location';
import { ManfrediteAvailabilityStatusValues } from './manfredite-availability-status';
import { ManfrediteContractTypeValues } from './manfredite-contract-type';
import { ManfrediteOffers } from './manfredite-offers';
import { ProfilePreferences } from './profile-preferences/profile-preferences';
import { RoleSummary } from './roles/role-summary';
import { Salary } from './salary/salary';
import { SoftSkill } from './soft-skills/soft-skill';
import { TagSummary } from './tags/tag-summary';
import { ManfrediteTechnologyResponse } from './techs';
import { TechSummary } from './techs/tech-summary';
import { WorkplacePreferences } from './workplace-preferences/workplace-preferences';
import { YearsOfExperience } from './years-of-experience/years-of-experience';
/**
 * Affected endpoints
 * GET /manfredite
 * PUT /manfredite
 */
export class ManfrediteResponse {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], ManfrediteResponse.prototype, "profileId", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], ManfrediteResponse.prototype, "manfrediteId", void 0);
__decorate([
    IsString(),
    MaxLength(320),
    IsEmail(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "email", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "firstName", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "lastName", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => Location),
    IsOptional(),
    __metadata("design:type", Location)
], ManfrediteResponse.prototype, "whereDoYouLive", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "telephone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "headline", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "introduction", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SoftSkill),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "softSkills", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "goodPractices", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Fact),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "facts", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => Links),
    __metadata("design:type", Links)
], ManfrediteResponse.prototype, "links", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => YearsOfExperience),
    IsOptional(),
    __metadata("design:type", YearsOfExperience)
], ManfrediteResponse.prototype, "yearsOfExperience", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => RoleSummary),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "desiredRoles", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => Salary),
    IsOptional(),
    __metadata("design:type", Salary)
], ManfrediteResponse.prototype, "desiredSalary", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "desiredSalaryDescription", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteResponse.prototype, "currentSalary", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "desiredJobDescription", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ManfrediteTechnologyResponse),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "techs", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TechSummary),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "likedTechs", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TechSummary),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "dislikedTechs", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => WorkplacePreferences),
    __metadata("design:type", WorkplacePreferences)
], ManfrediteResponse.prototype, "workplacePreferences", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => ProfilePreferences),
    __metadata("design:type", ProfilePreferences)
], ManfrediteResponse.prototype, "profilePreferences", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => MediaSummary),
    IsOptional(),
    __metadata("design:type", MediaSummary)
], ManfrediteResponse.prototype, "cvFile", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => MediaSummary),
    IsOptional(),
    __metadata("design:type", MediaSummary)
], ManfrediteResponse.prototype, "avatar", void 0);
__decorate([
    IsString(),
    IsIn(ManfrediteAvailabilityStatusValues),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "availabilityStatus", void 0);
__decorate([
    IsArray(),
    IsIn(ManfrediteContractTypeValues, { each: true }),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "contractTypes", void 0);
__decorate([
    IsString(),
    IsIn(['EN', 'ES']),
    __metadata("design:type", String)
], ManfrediteResponse.prototype, "preferredLanguage", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ManfrediteResponse.prototype, "isNewsletterActive", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ManfrediteResponse.prototype, "hasOnboardingComplete", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ManfrediteResponse.prototype, "isInterestedOnWorkAtManfred", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ManfrediteResponse.prototype, "isLegacy", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => ManfrediteOffers),
    __metadata("design:type", ManfrediteOffers)
], ManfrediteResponse.prototype, "offers", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TagSummary),
    __metadata("design:type", Array)
], ManfrediteResponse.prototype, "tags", void 0);
//# sourceMappingURL=manfredite.response.js.map